import { baseStagingEnvironment } from '@environments/_base/staging.environment';
import { EnvironmentSettings } from '../types';

export const environment: EnvironmentSettings = {
  ...baseStagingEnvironment,
  firebase: {
    apiKey: 'AIzaSyDDcRNzmzE-giCaoASSQUyM6kiXT5Rne8E',
    appId: '1:380839439958:web:da2146ab0822bf615bd5f7',
    authDomain: 'pearsports-staging.firebaseapp.com',
    measurementId: 'G-0YR85MX4YS',
    messagingSenderId: '380839439958',
    projectId: 'pearsports-staging',
    storageBucket: 'pearsports-staging.appspot.com',
  },
};
